import React from 'react'
import { Link as RouteLink } from 'react-router-dom'
import { Typography, Link, Divider, Breadcrumbs as BreadcrumbsComponent } from '@mui/material'

import { useStyles } from './styles'

export const Breadcrumbs = ( { crumbs } ) => {
	const classes = useStyles()

	return (
		<BreadcrumbsComponent
			aria-label='breadcrumb'
			paddingY='10px'
			borderBottom='1px solid var(--line)'
			paddingLeft={ 4 }
			color='var(--line)'
			alignItems='initial'
			separator={ <Divider orientation='vertical' height='20px'/> }
			className={ classes.breadcrumbs }
		>
			{ crumbs.map( ( { id, path, name }, key ) => {
				if ( key + 1 === crumbs.length ) {
					return (
						<Typography color='text.primary' key={ id } >{ name }</Typography>
					)
				} else {
					return (
						<Link
							key={ id }
							component={ RouteLink }
							to={ path }
							underline='hover'
							color='inherit'
						>
							{ name }
						</Link>
					)
				}
			} ) }
		</BreadcrumbsComponent>
	)
}
